// src/brandConfig.js
export const brandConfig = {
  companyName: "Hijra Tours",
  contactEmail: "Hijratourandtravel@gmail.com",
  facebookLink: "https://www.facebook.com/share/1KXtvmCoZq/?mibextid=wwXIfr",
  instagramLink: "https://www.instagram.com/hijraatravel?igsh=MTl0end2OGZhaGh0dg==",
  cmsDashboardTitle: "CMS Dashboard | Hijra Tours",
};
